module.exports = __webpack_public_path__ + "static/media/series.c00aac66.svg";